// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");

function WizardPriceRangeFields(props) {
  let __showFieldValidations = props.showFieldValidations;
  let widthMd = props.widthMd;
  let width = props.width;
  let maxPrice = props.maxPrice;
  let minPrice = props.minPrice;
  let showFieldValidations = __showFieldValidations !== undefined ? __showFieldValidations : true;
  let minPriceStatus = showFieldValidations ? minPrice.status : undefined;
  let maxPriceStatus = showFieldValidations ? maxPrice.status : undefined;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: width,
        widthMd: widthMd,
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            labelText: props.minPriceLabel,
            onChange: event => minPrice.onChange(Form__Helpers.intFromFormattedPrice(event)),
            onBlur: param => minPrice.onBlur(),
            onFocus: param => minPrice.onFocus(),
            status: minPriceStatus,
            prepend: "$",
            value: Form__Helpers.intOptToFormattedPrice(minPrice.value)
          }),
          showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
              valid: minPrice.valid
            }) : null
        ]
      }),
      JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: width,
        widthMd: widthMd,
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            labelText: props.maxPriceLabel,
            onChange: event => maxPrice.onChange(Form__Helpers.intFromFormattedPrice(event)),
            onBlur: param => maxPrice.onBlur(),
            onFocus: param => maxPrice.onFocus(),
            status: maxPriceStatus,
            prepend: "$",
            value: Form__Helpers.intOptToFormattedPrice(maxPrice.value)
          }),
          showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
              valid: maxPrice.valid
            }) : null
        ]
      })
    ]
  });
}

let Cell;

let TextInputField;

let make = WizardPriceRangeFields;

exports.Cell = Cell;
exports.TextInputField = TextInputField;
exports.make = make;
/* Form__Input Not a pure module */
